export enum Steps {
  CoverImagesChoosing,
  CropsChoosing,
  BrandingsChoosing,
  LogosChoosing,
  CompanyInfoChoosing,
  Step5,
}



// WEBPACK FOOTER //
// ./src/infrastructure/Steps.ts